// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"list_wrapper__1l3a0"};